"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiServer = exports.api = void 0;
require("isomorphic-fetch");
var _useragent = require("@kiwicom/useragent");
var _headers = require("../fetch/headers");
var _handlers = require("../fetch/handlers");
const sendGTM = payload => {
  if (Array.isArray(window.dataLayer)) {
    // eslint-disable-next-line fp/no-mutating-methods
    window.dataLayer.push(payload);
  }
};
const defaultHeaders = _headers.JSON_BOTH;
const sendLogLady = ({
  settings,
  payload
}) => {
  const body = JSON.stringify(payload);
  return fetch(settings.url, {
    method: "POST",
    headers: defaultHeaders,
    body
  }).then(_handlers.handleError).then(() => {}).catch(() => {});
};
const getEnvironment = payload => {
  if (payload.global.isProduction === true) {
    return "production";
  } else if (payload.global.isPreproduction === true) {
    return "preproduction";
  } else if (payload.global.isSandbox === true) {
    return "sandbox";
  } else if (payload.global.isDevelopment === true) {
    return "development";
  }
  return "unknown";
};
const getUserAgent = ({
  settings,
  payload
}) => {
  var _payload$global$modul, _settings$moduleVersi;
  if (payload.global.module == null) {
    // eslint-disable-next-line no-console
    console.warn("Logger: Missing 'module' field on the logger's globals will result in incorrect RFC22 user-agent.");
  }
  if (settings.moduleVersion == null) {
    // eslint-disable-next-line no-console
    console.warn("Logger: Missing 'moduleVersion' field on the logger's settings will result in incorrect RFC22 user-agent.");
  }
  return (0, _useragent.format)((_payload$global$modul = payload.global.module) !== null && _payload$global$modul !== void 0 ? _payload$global$modul : "@kiwicom/nitro", (_settings$moduleVersi = settings.moduleVersion) !== null && _settings$moduleVersi !== void 0 ? _settings$moduleVersi : "N/A", getEnvironment(payload));
};
const sendLogLadyServer = ({
  settings,
  payload
}) => {
  const body = JSON.stringify(payload);
  const headers = {
    ...defaultHeaders,
    "User-Agent": getUserAgent({
      settings,
      payload
    })
  };
  return fetch(settings.url, {
    method: "POST",
    headers,
    body
  }).then(_handlers.handleError).then(() => {}).catch(e => {
    // eslint-disable-next-line no-console
    console.error("%c[Nitro]", "color: red;", "log", "Fetch call to logging endpoint failed with payload:", payload);
    // eslint-disable-next-line no-console
    console.error(e);
  });
};
const log = (payload, settings) => {
  if (settings.debug) {
    // eslint-disable-next-line no-console
    console.log("%c[Nitro]", "color: lime;", "log", payload);
  }
  if (settings.gtm) {
    sendGTM(payload);
  }
  if (settings.enabled) {
    return sendLogLady({
      settings,
      payload
    });
  }
  return Promise.resolve();
};
const logServer = (payload, settings) => {
  if (settings.debug) {
    // eslint-disable-next-line no-console
    console.log("%c[Nitro]", "color: lime;", "log", payload);
  }
  if (settings.enabled) {
    return sendLogLadyServer({
      settings,
      payload
    });
  }
  return Promise.resolve();
};
const api = log;
exports.api = api;
const apiServer = logServer;
exports.apiServer = apiServer;